import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const HELPFUL_LINKS = [
  { to: '/start', label: 'Get Started', note: '$100 credit' },
  { to: '/', label: 'Home', note: 'Start over' },
  { to: '/live-apps', label: 'Live Apps', note: 'Work in production' },
  { to: '/projects', label: 'Projects', note: 'Web, graphics, video' },
  { to: '/products', label: 'Pricing', note: 'Tiers and add-ons' },
  { to: '/crew', label: 'Crew', note: 'Who builds it' },
  { to: '/contact?reason=contact', label: 'Contact', note: 'Talk to us' },
];

const NotFound = () => (
  <main className="not-found" id="main">
    <div className="not-found-grid" aria-hidden="true" />
    <div className="not-found-orb" aria-hidden="true" />

    <div className="container not-found-inner">
      <p className="eyebrow reveal reveal-fade">Error 404</p>

      <h1 className="not-found-code">
        <span className="reveal-mask">
          <span>404</span>
        </span>
      </h1>

      <h2 className="not-found-title reveal reveal-up" style={{ '--reveal-delay': '0.1s' }}>
        This page doesn&rsquo;t exist.
      </h2>

      <p className="not-found-text reveal reveal-up" style={{ '--reveal-delay': '0.16s' }}>
        It may have been moved, renamed, or never built in the first place. Here&rsquo;s
        the way back.
      </p>

      <div className="btn-row not-found-actions reveal reveal-up" style={{ '--reveal-delay': '0.22s' }}>
        <Link to="/" className="btn btn--primary btn--lg">
          Go home <span className="btn-arrow">→</span>
        </Link>
        <Link to="/contact?reason=contact" className="btn btn--ghost btn--lg">
          Report a broken link
        </Link>
      </div>

      <div className="not-found-links">
        <h3>You might be looking for</h3>
        <ul data-stagger="0.04">
          {HELPFUL_LINKS.map((link) => (
            <li className="reveal reveal-up" key={link.label}>
              <Link to={link.to}>
                <span className="not-found-link-label">{link.label}</span>
                <span className="not-found-link-note">{link.note}</span>
                <span className="btn-arrow" aria-hidden="true">
                  →
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </main>
);

export default NotFound;
